import React, { Component } from "react";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { CommonContext } from "./context/CommonContext";
// import { renderRoutes } from 'react-router-config';
import {
  getLanguageData,
  getAllLanguage,
  setLanguage,
} from "./services/languageService";
import LoginForm from "./components/auth/loginForm";
import ProtectedRoute from "./components/auth/protectedRoute";
import Loadable from "react-loadable";
import "react-toastify/dist/ReactToastify.css";
import "./App.scss";
import "./App.css";
import { Object } from "core-js";
import { webPath } from "./config.json";

const loading = () => (
  <div className="animated fadeIn pt-3 text-center">Loading...</div>
);

// Containers
const DefaultLayout = Loadable({
  loader: () => import("./containers/DefaultLayout"),
  loading,
});

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      common: {
        languageData: {},
      },
    };
  }

  componentDidMount = async () => {
    localStorage.removeItem("merchantNav");
    localStorage.removeItem("adminNav");
    var languagePath = await localStorage.getItem("CokeAdminLanguagePath");
    if (!languagePath || languagePath == null) {
      const { data: siteLanguages } = await getAllLanguage();
      if (siteLanguages.data.length > 0) {
        setLanguage(siteLanguages.data[0]);
        languagePath = siteLanguages.data[0].directory;
      } else {
        languagePath = "eng";
      }
    }
    const { data } = await getLanguageData(languagePath);
    var languages = JSON.parse(data.data);
    var languageData = {};
    var a = 0;
    var count = Object.entries(languages).length;
    await Promise.all(
      Object.entries(languages).map(async ([key, value]) => {
        a++;
        languageData[key] = value;
        if (a === count) {
          var common = this.state.common;
          common.languageData = languageData;
          this.setState({ common });
        }
      })
    );
  };

  render() {
    return (
      <CommonContext.Provider value={this.state.common}>
        <React.Fragment>
          <ToastContainer />
          <BrowserRouter basename={webPath}>
            <Switch>
              <Route
                exact
                path="/login"
                name="Login Page"
                component={LoginForm}
                common={this.state.common}
              />
              <ProtectedRoute
                path="/"
                name="Home"
                component={DefaultLayout}
                common={this.state.common}
              />
            </Switch>
          </BrowserRouter>
        </React.Fragment>
      </CommonContext.Provider>
    );
  }
}

export default App;
